import axios from "axios";

const API =  axios.create({
  baseURL: "https://api-console.tempalarm.gr", 
  responseType: "json"
});

export default API
